// extracted by css-extract-rspack-plugin
var _1 = "OBqM4A_b6f8EduT4";
var _2 = "sdNXUucxl0AvG9a2";
var _3 = "O9bDMRNDHW4oc4L9";
var _4 = "W6Xyf1mjpuAD3Dvs";
var _5 = "_QktjKTyEdi2_uCd";
var _6 = "OBqM4A_b6f8EduT4";
var _7 = "sdNXUucxl0AvG9a2";
var _8 = "O9bDMRNDHW4oc4L9";
var _9 = "W6Xyf1mjpuAD3Dvs";
var _a = "_QktjKTyEdi2_uCd";
export { _1 as "knockout-round-title", _2 as "knockout-teams", _3 as "knockout-teams-calendar", _4 as "knockout-title", _5 as "knockout-wrap--more-rounds", _6 as "knockoutRoundTitle", _7 as "knockoutTeams", _8 as "knockoutTeamsCalendar", _9 as "knockoutTitle", _a as "knockoutWrapMoreRounds" }
